import React from 'react';

import { StyledContent } from '../../constants/styledComponents';

const Content = ({ tag: Tag = 'div', isSidebarOpen, ...props }) => {
  return <StyledContent as={Tag} isSidebarOpen={isSidebarOpen} {...props} />;
};

export default Content;
